import * as React from 'react';
import { parseImageUrl } from '../../drupal/rendering/image_utils.mod';
import { ParsedImageFileWithTargetItem } from '../../../../Client/components/drupal/types_and_parser/types';

type Visual =
  'mint' |
  'orange' |
  'lemon' |
  'lime' |
  'coke' |
  'vacancies' |
  'esg'

type Vacancy =
  'administration' |
  'engineering' |
  'finance-it' |
  'health-safety' |
  'hr' |
  'manufacturing' |
  'other' |
  'purchasing' |
  'sales-marketing' |
  'supply-chain' |
  'warehouse';

export function VacancyTypeCheck(str: string): Vacancy {
  switch (str.toLowerCase()) {
    case 'administration':
      return 'administration';
    case 'engineering':
      return 'engineering';
    case 'finance-it':
      return 'finance-it';
    case 'health, safety & environment':
      return 'health-safety';
    case 'hr':
      return 'hr';
    case 'manufacturing':
      return 'manufacturing';
    case 'purchasing':
      return 'purchasing';
    case 'sales marketing':
      return 'sales-marketing';
    case 'supply chain':
      return 'supply-chain';
    case 'warehouse':
      return 'warehouse';
    default:
      return 'other';
  }
}

export function renderVisual(str: string): Visual {
  switch (str.toLowerCase()) {
    case 'coke':
      return 'coke';
    case 'lemon':
      return 'lemon';
    case 'lime':
      return 'lime';
    case 'mint':
      return 'mint';
    case 'orange':
      return 'orange';
    case 'vacancies':
      return 'vacancies';
    case 'esg':
      return 'esg';
    default:
      return 'mint';
  }
}

type HeroProps = {
  visual?: Visual;
  vacancy?: Vacancy;
  image?: ParsedImageFileWithTargetItem;
  hasFixedImg: boolean;
  hasCMSImg: boolean;
  hasVacancyImg: boolean;
  hasNoBranding?: boolean;
}

class HeroVisual extends React.Component<HeroProps, never> {
  private svgPath = '';

  constructor(props: HeroProps) {
    super(props);
  }

  componentDidMount() {
    switch (this.props.visual) {
      case 'coke':
        this.svgPath = 'M77.9997 516C77.9997 516 -79.9985 597.694 67.0768 621.917C243.99 651.054 613.489 692.647 892.406 605.62C1177.68 516.609 1022.07 281.2 804.501 270.5M351.001 299.5C300.354 303.067 77.9997 371 52.0007 424C-26.1141 583.24 365.2 704.07 592.807 749C1004.4 830.25 1333.16 732.703 1132 605.62';
        break;
      case 'lemon':
        this.svgPath = 'M62.0002 523C62.0002 523 -79.9984 597.694 67.0769 621.917C243.99 651.054 410.707 638.749 701.001 605.62C925.501 580 1032.5 526 852 426M290 300C179.5 274.5 85.9998 268 60.0008 321C-18.1141 480.24 365.201 704.07 592.807 749C1004.4 830.25 1320.16 725.084 1119 598';
        break;
      case 'lime':
        this.svgPath = 'M77.9997 516C77.9997 516 -68.0015 568 67.0768 621.917C233.598 688.384 534.084 692.647 813 605.62C1098.28 516.609 1203.5 350 1142.5 350M475.999 283C409.999 276 136.375 252 52.0007 424C-26.1141 583.24 365.2 704.07 592.806 749C1004.4 830.25 1333.16 732.703 1132 605.62';
        break;
      case 'mint':
        this.svgPath = 'M77.9995 516C77.9995 516 -79.9987 597.694 67.0766 621.917C243.99 651.054 613.489 692.647 892.405 605.62C1177.68 516.609 1104.57 275.7 887 265M253 307C202.354 310.567 77.9995 371 52.0005 424C-26.1143 583.24 365.2 704.07 592.806 749C1004.4 830.25 1333.16 732.703 1132 605.62';
        break;
      case 'orange':
        this.svgPath = 'M77.9998 516C77.9998 516 -79.9984 597.694 67.0769 621.917C243.99 651.054 613.489 692.647 892.406 605.62C1177.68 516.609 1038.57 332.2 821.001 321.5M367.501 376.5C311.501 389 167.5 407 141.501 460C63.3859 619.24 365.2 704.07 592.807 749C1004.4 830.25 1333.16 732.703 1132 605.62';
        break;
      case 'vacancies':
        this.svgPath = 'M118.919 548.074C-6.62216 529.799 19.5969 770.552 211.879 810.281C264.169 821.085 748.435 888.325 810.984 890.532M886.469 442.397C901.566 291.43 1269.45 411.409 1216.21 645.806C1193.54 745.615 1125.63 827.761 985.788 834.118';
        break;
      case 'esg':
        this.svgPath = 'M83 535C-9.16662 578.5 -63.5 666.6 456.5 671C1106.5 676.5 1133 477.5 1024.5 400M184 442C102.833 505.833 66.6525 684.155 593 771C1241.5 878 1289.5 685.5 1121.5 601.5';
        break;
      default:
        this.svgPath = '';
        break;
    }
  }

  componentWillUnmount(): void {
    this.svgPath = '';
  }

  render(): React.ReactNode {
    const {
      hasFixedImg,
      hasCMSImg,
      hasVacancyImg,
      visual,
      image,
      vacancy,
      hasNoBranding,
    } = this.props;
    return (
      !hasNoBranding ? (
        <div className={`pageheader__visual ${hasFixedImg ? `pageheader__visual--${visual}` : ''}`}>
          {hasFixedImg ?
            <>
              <img
                className="pageheader__image"
                src={`/frontend/images/hero/${visual}-s.png`}
                srcSet={`/frontend/images/hero/${visual}-s.png 600w, /frontend/images/hero/${visual}-l.png 1225w`}
                width="1225"
                height="1070"
                alt={visual}
                sizes="(min-width: 1200px) 800px, 500px" />
              <svg className="pageheader__svg" width="1225" height="1070" viewBox="0 0 1225 1070" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="pageheader__swirlie" d={`${this.svgPath}`} strokeWidth="5" strokeLinecap="round" />
              </svg>
            </>
            :
            <></>
          }
          {hasCMSImg ?
            <>
              <div className="pageheader__image-container">
                <img
                  className="pageheader__image"
                  alt={image?.alt}
                  width="850"
                  height="850"
                  src={`${parseImageUrl(image?.image?.style_urls['425w'])}`}
                  srcSet={`${parseImageUrl(
                    image?.image?.style_urls['425w']
                  )} 425w, ${parseImageUrl(
                    image?.image?.style_urls['850w']
                  )} 850w, ${parseImageUrl(
                    image?.image?.style_urls['1225w']
                  )} 1225w`}
                  sizes="(min-width: 1200px) 800px, 500px"
                />
              </div>
              <svg className="pageheader__svg" width="1200" height="1200" viewBox="0 0 1200 1200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="pageheader__swirlie" d="M116.653 821.662C-118.097 891.515 -10.4577 1082.75 548.363 1036.95C1107.18 991.141 1374 591.492 1077.41 568.59" strokeWidth="5" strokeLinecap="round" />
              </svg>
            </>
            :
            <></>
          }
          {
            hasVacancyImg ?
              <>
                <div className="pageheader__image-container">
                  <img
                    className="pageheader__image lazyload"
                    alt={vacancy}
                    width="850"
                    height="850"
                    src={`/frontend/images/vacancies/${vacancy}-s.jpg`}
                    data-srcset={`/frontend/images/vacancies/${vacancy}-s.jpg 600w, /frontend/images/vacancies/${vacancy}-l.jpg 1225w`}
                    sizes="(min-width: 1200px) 800px, 500px"
                  />
                </div>
                <svg className="pageheader__svg" width="1200" height="1200" viewBox="0 0 1200 1200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="pageheader__swirlie" d="M116.653 821.662C-118.097 891.515 -10.4577 1082.75 548.363 1036.95C1107.18 991.141 1374 591.492 1077.41 568.59" strokeWidth="5" strokeLinecap="round" />
                </svg>
              </>
              :
              <></>
          }
        </div>
      )
      : 
      ( <></> )
    )
  }
}

export default HeroVisual;